import { FC } from 'react';

import { Flex, Divider } from '@servicetitan/anvil2';
import { BodyText } from '@servicetitan/design-system';

import { TelecomBrandData } from '../api/telecom.api';
import { SectionCard } from './section-card';

import * as Styles from './campaigns-card.module.less';

interface CampaignsCardProps {
    brand: TelecomBrandData;
}

export const CampaignsCard: FC<CampaignsCardProps> = ({ brand }) => {
    const campaigns = brand.campaigns || [];

    return (
        <SectionCard title="Campaigns">
            <Flex direction="column" gap="4">
                {campaigns.length === 0 ? (
                    <BodyText size="small">No campaigns available</BodyText>
                ) : (
                    campaigns.map((campaign, index) => (
                        <div key={campaign.id}>
                            <Flex direction="column" gap="3">
                                {/* Campaign Header with ID and External ID */}
                                <BodyText bold size="small">
                                    {campaign.id}
                                    {campaign.externalId ? ` (${campaign.externalId})` : ''}
                                </BodyText>

                                {/* Use Cases Section */}
                                {campaign.useCases && campaign.useCases.length > 0 && (
                                    <div>
                                        <BodyText bold size="small" className={Styles.sectionTitle}>
                                            Use Cases:
                                        </BodyText>
                                        <ul className={Styles.list}>
                                            {campaign.useCases.map(useCase => (
                                                <li key={useCase} className={Styles.listItem}>
                                                    <BodyText size="small">
                                                        {useCase.toUpperCase()}
                                                    </BodyText>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {campaign.phoneNumbers && campaign.phoneNumbers.length > 0 && (
                                    <div>
                                        <BodyText bold size="small" className={Styles.sectionTitle}>
                                            Associated Phone Numbers:
                                        </BodyText>
                                        <ul className={Styles.list}>
                                            {campaign.phoneNumbers.map(phoneNumber => (
                                                <li key={phoneNumber} className={Styles.listItem}>
                                                    <BodyText size="small">{phoneNumber}</BodyText>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </Flex>

                            {index < campaigns.length - 1 && <Divider />}
                        </div>
                    ))
                )}
            </Flex>
        </SectionCard>
    );
};
